import { createContext, useContext } from 'react';

export interface ThemeContextType {
  toggleTheme: () => void;
  isVite: boolean;
  isNextJs: boolean;
  is5ers: boolean;
  isTtp: boolean;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const useThemeContext = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useThemeContext must be used within a ThemeProvider');
  }
  return context;
};

export { ThemeContext };
